/* ==========================================================================
   AURRA — Standard Shipping timeline dates
   ==========================================================================

   Recomputes the three dates in the browser. Liquid already rendered them,
   but Shopify caches product HTML, so a page built at 23:50 would still be
   telling a visitor at 00:10 that their order goes out "tomorrow, Thursday"
   when tomorrow is now Friday. Whatever the customer's clock says wins.

   Windows match the published policy: dispatch in 1-2 days, delivery in
   3-5. Friday is skipped - Egyptian weekend, no courier collection.
   ========================================================================== */
(function () {
  'use strict';

  try {
    var root = document.querySelector('[data-aurra-ship]');
    if (!root) return;

    var DAY = 86400000;
    var FRIDAY = 5;

    /* Advance `n` WORKING days, never counting a Friday.

       An earlier version added n calendar days and then bumped the result
       forward if it happened to land on a Friday. That kept Friday off the
       label but broke the arithmetic: ordering on a Thursday made day 1 and
       day 2 collapse onto the same Saturday, and the row rendered
       "Sat 22 Aug – Sat 22 Aug". Counting the days properly means Friday is
       skipped over rather than landed on and shoved, so the window keeps its
       real width and simply widens across the weekend. */
    function addWorkingDays(from, n) {
      var d = new Date(from.getTime());
      var added = 0;
      var guard = 0;
      while (added < n && guard++ < 30) {
        d = new Date(d.getTime() + DAY);
        if (d.getDay() !== FRIDAY) added++;
      }
      return d;
    }

    function fmt(d) {
      return d.toLocaleDateString('en-GB', {
        weekday: 'short',
        day: 'numeric',
        month: 'short'
      });
    }

    /* Collapse "Sat 22 Aug – Sat 22 Aug" to a single date. */
    function range(a, b) {
      var x = fmt(a);
      var y = fmt(b);
      return x === y ? x : x + ' – ' + y;
    }

    var today = new Date();
    var set = function (sel, text) {
      var el = root.querySelector(sel);
      if (el) el.textContent = text;
    };

    set('[data-ship-placed]', fmt(today));
    set('[data-ship-dispatched]', range(addWorkingDays(today, 1), addWorkingDays(today, 2)));
    set('[data-ship-delivered]', range(addWorkingDays(today, 3), addWorkingDays(today, 4)));
  } catch (e) {
    if (window.console && console.warn) console.warn('[aurra-shipping-timeline]', e);
  }
})();
